import RenderforestFooter from './RenderforestFooter'
export default RenderforestFooter
